import { render } from "./VideoRemove.vue?vue&type=template&id=13844bac&scoped=true"
import script from "./VideoRemove.vue?vue&type=script&lang=js"
export * from "./VideoRemove.vue?vue&type=script&lang=js"

import "./VideoRemove.vue?vue&type=style&index=0&id=13844bac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13844bac"]])

export default __exports__